import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Subscription } from 'rxjs';

import { ViewContextService } from 'app/navigation/view-context.service';
import { EnableRequestLoggerInput } from 'app/shared/graph';


@Component({
    selector: 'admin-add-request-logger-rule-dialog',
    templateUrl: './add-request-logger-rule-dialog.component.html',
    styleUrls: ['./add-request-logger-rule-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatHint, MatSuffix, MatDialogActions, MatButton, MatDialogClose],
})
export class AddRequestLoggerRuleDialogComponent implements OnInit, OnDestroy {
    viewContextService = inject(ViewContextService);

    subscriptions = new Subscription();
    ruleInfo: EnableRequestLoggerInput = {
        routePrefix: '/',
        statusCode: 400,
        maximumCaptureCount: 10,
        logsExpirationInSeconds: 3600,
    };

    ngOnInit(): void {
        this.subscriptions.add(this.viewContextService.context$.subscribe(context => {
            console.warn(context);
            if (context.type == 'store') {
                this.ruleInfo.storeId = context.storeId;
            }
        }));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
